export type ConversionType =
  | "lead_submitted"
  | "lead_qualified"
  | "lead_won"
  | "user_signed_up"
  | "product_uploaded"
  | "order_placed"
  | "order_paid";

export interface ConversionProperties {
  entityId?: string;
  value?: number;
  currency?: string;
  qualityTier?: string;
  qualityTierSource?: "auto" | "manual";
  productTypeSlug?: string;
  productTypeName?: string;
  quantity?: number;
  leadType?: string;
  attributionChannel?: string;
  surface?: string;
  [key: string]: unknown;
}

const firedKeys = new Set<string>();
function dedupeKey(type: ConversionType, entityId?: string): string | null {
  return entityId ? `${type}:${entityId}` : null;
}

function toDataLayerPayload(type: ConversionType, props: ConversionProperties) {
  return {
    event: "conversion",
    conversion_type: type,
    lead_id: props.entityId,
    value: props.value,
    currency: props.currency ?? "USD",
    quality_tier: props.qualityTier,
    quality_tier_source: props.qualityTierSource,
    product_type_slug: props.productTypeSlug,
    product_type_name: props.productTypeName,
    quantity: props.quantity,
    lead_type: props.leadType,
    attribution_channel: props.attributionChannel,
    surface: props.surface,
  };
}

export function trackConversion(
  type: ConversionType,
  properties: ConversionProperties = {},
): void {
  const key = dedupeKey(type, properties.entityId);
  if (key) {
    if (firedKeys.has(key)) return;
    firedKeys.add(key);
  }

  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(toDataLayerPayload(type, properties));
  }

}
